// boosters

export type ResourceId =
  | 'bomb'
  | 'bullet'
  | 'cube'
  | 'dart'
  | 'drill'
  | 'gold'
  | 'kcoin'
  | 'life'
  | 'rocket'
  | 'roulette';

//-----------------------------------------------------------------------------
export const boosterIds = ['dart', 'bullet', 'drill', 'roulette'] as const;
export type BoosterId = (typeof boosterIds)[number];
export type BoosterEntry = {
  count: number;
};
export type BoosterCollection = { [key in BoosterId]?: BoosterEntry };

// maps
//-----------------------------------------------------------------------------
export const boosterMap: {
  [key in BoosterId]: {
    text: string;
    tip: string;
    cost: number; // in gold
  };
} = {
  dart: {
    text: '[boosterDart]',
    tip: '[tipBoosterDart]',
    cost: 40,
  },
  bullet: {
    text: '[boosterBullet]',
    tip: '[tipBoosterBullet]',
    cost: 80,
  },
  drill: {
    text: '[boosterDrill]',
    tip: '[tipBoosterDrill]',
    cost: 80,
  },
  roulette: {
    text: '[boosterRoulette]',
    tip: '[tipBoosterRoulette]',
    cost: 20,
  },
};

// helpers
//-----------------------------------------------------------------------------
export function isResourceBooster(resourceId: ResourceId): boolean {
  return !!boosterMap[resourceId as BoosterId];
}
